/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  GetMarketMakerSelfOptions,
  GetMarketMakerSelfResponses,
} from '../types/GetMarketMakerSelf'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Any authenticated user. Returns the market maker configuration whose user_id is the caller, or 404 when the caller is not a market maker.
 * @summary Get the caller's market maker
 * {@link /v1/market-makers/self}
 */
export function getMarketMakerSelf<ThrowOnError extends boolean = true>(
  options: Options<GetMarketMakerSelfOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<GetMarketMakerSelfResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/market-makers/self',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<GetMarketMakerSelfResponses, ThrowOnError>>,
  )
}
